export interface Demographics {
  firstName: string;
  lastName: string;
  middleName: string;
  nameSuffix: string;
  dateOfBirth: string;
  preferredSex: string;
  mrn?: string;
}

export const EmptyDemographics: Demographics = {
  firstName: '',
  lastName: '',
  middleName: '',
  nameSuffix: '',
  dateOfBirth: '',
  preferredSex: '',
};

export const formatPatientName = (demographics?: Demographics): string => {
  return demographics
    ? `${demographics.firstName ?? ''} ${demographics.middleName ?? ''} ${
        demographics.lastName ?? ''
      } ${demographics.nameSuffix ?? ''}`.trim()
    : '';
};
